export default __webpack_public_path__ + "static/media/BgLine.833a9d3c.svg";